import axios from 'axios'
import Cookies from 'universal-cookie'
import queryString from 'query-string'

export function getCampaign(id, fetchStats, from, to) {
    return axios.get(`/api/campaign/${id}?stats=${fetchStats}&from=${from}&to=${to}`).then(res => res.data)
}

export function next(
    questionContainerId,
    answers,
    questionPageId,
    visitorSessionId,
    direction,
    skip = null,
    appType = null,
    affiliateTag = null,
    platformId = null,
    conversionTestKey = null,
    prea = null,
    p = null,
    lang = null
) {
    let url = process.env.MIX_API_URL + '/aq/next'
    const location = window.location
    const cookies = new Cookies()
    const parsedQueryString = queryString.parse(location.search)
    const visitorHash = parsedQueryString['vc'] ? parsedQueryString['vc'] : cookies.get('vc')

    return axios
        .post(
            url,
            {
                process_url: location.origin + location.pathname,
                answers: answers,
                question_page_id: questionPageId,
                question_container_id: questionContainerId,
                platform_id: platformId,
                visitor_session_id: visitorSessionId,
                vc: parsedQueryString['reset'] !== undefined ? null : visitorHash,
                direction: direction,
                utm_campaign: parsedQueryString['utm_campaign'],
                utm_source: parsedQueryString['utm_source'],
                utm_medium: parsedQueryString['utm_medium'],
                utm_content: parsedQueryString['utm_content'],
                utm_term: parsedQueryString['utm_term'],
                subid: parsedQueryString['subid'],
                subid2: parsedQueryString['subid2'],
                subid3: parsedQueryString['subid3'],
                subid4: parsedQueryString['subid4'],
                subid5: parsedQueryString['subid5'],
                affiliate_tag: affiliateTag ? affiliateTag : parsedQueryString['affiliate_tag'],
                sqps: skip ? JSON.stringify(skip) : parsedQueryString['sqps'],
                prea: prea ? JSON.stringify(prea) : parsedQueryString['prea'],
                vs: parsedQueryString['vs'],
                qpg: parsedQueryString['qpg'],
                test: parsedQueryString['test'],
                appType: appType,
                conversionTestKey: conversionTestKey,
                reset: parsedQueryString['reset'],
                p: p ? p : parsedQueryString['p'],
                at_gd: parsedQueryString['at_gd'],
                lang: lang ? lang : parsedQueryString['lang']
            },
            { withCredentials: false }
        )
        .then(res => res.data)
}

export function start() {
    let url = process.env.MIX_API_URL + '/aq/next'
    const cookies = new Cookies()

    const parsedQueryString = queryString.parse(window.location.search)

    let token = parsedQueryString['token']
    return axios
        .post(url, {
            is_pre_process_visit: 1,
            question_container_id: process.env.MIX_DEFAULT_QUESTION_CONTAINER_ID,
            u: cookies.get('vc'),
            utm_campaign: parsedQueryString['utm_campaign'],
            utm_source: parsedQueryString['utm_source'],
            utm_medium: parsedQueryString['utm_medium'],
            utm_content: parsedQueryString['utm_content'],
            utm_term: parsedQueryString['utm_term'],
            subid: parsedQueryString['subid'],
            subid2: parsedQueryString['subid2'],
            subid3: parsedQueryString['subid3'],
            subid4: parsedQueryString['subid4'],
            subid5: parsedQueryString['subid5'],
            affiliate_tag: parsedQueryString['affiliate_tag']
        })
        .then(res => res.data)
}

export function getConversionPage(visitorSessionHash) {
    return axios.get(process.env.MIX_API_URL + `/aq/conversions?hash=${visitorSessionHash}`).then(res => res.data)
}

export function getValidateEmail(email) {
    let url = process.env.MIX_API_URL + '/aq/v/email?email=' + email
    return axios.get(url).then(res => res.data)
}

export function getCompanySuggestions(value) {
    let url = process.env.MIX_API_URL + '/get-company-suggestions?value=' + value
    return axios.get(url).then(res => res.data)
}

export function getCompanyDetails(businessId) {
    let url = process.env.MIX_API_URL + '/get-company-details?businessId=' + businessId
    return axios.get(url).then(res => res.data)
}

export function removeUploadedFile(visitorSessionId, key) {
    let url = process.env.MIX_API_URL + '/aq/upload/remove?visitorSessionId=' + visitorSessionId + '&key=' + key
    return axios.get(url).then(res => res.data)
}

export function fetchTheme(theme, includeDraft) {
    const queryParameters = includeDraft ? 'includeDraft=1' : ''
    return axios.get(process.env.MIX_API_URL + '/theme/' + theme.id + '?' + queryParameters).then(res => res.data)
}

export function getExpenses(visitorSessionId) {
    let url = process.env.MIX_API_URL + '/factoring/expense-estimate?visitorSessionId=' + visitorSessionId
    return axios.get(url).then(res => res.data)
}
